import { FC, useId } from 'react'
import { useTranslation } from 'react-i18next'

import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'

import { ImportFlag } from '../../types/ImportTool'

type ImportFlagFieldProps = {
  label: string
  value: ImportFlag
  onChange: (value: ImportFlag) => void
}

export const ImportFlagField: FC<ImportFlagFieldProps> = ({ label, value, onChange }) => {
  const { t } = useTranslation()
  const labelId = useId()

  return (
    <FormControl>
      <FormLabel id={labelId}>{label}</FormLabel>
      <RadioGroup row aria-labelledby={labelId} value={value} onChange={(event) => onChange(event.target.value as ImportFlag)}>
        <FormControlLabel value="true" control={<Radio />} label={t('internal-common:yes')} />
        <FormControlLabel value="false" control={<Radio />} label={t('internal-common:no')} />
      </RadioGroup>
    </FormControl>
  )
}
